export { alterarPapelUsuario } from './actions';
export type { PapelAtribuivel } from './services';
export { clearError } from './slice';
export { default as usuarioPapelAdminReducer } from './slice';

import type { RootState } from '@/store';

export const selectPapelSaving = (state: RootState) => state.usuarioPapelAdmin.saving;
export const selectPapelError = (state: RootState) => state.usuarioPapelAdmin.error;
